'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

class InfrastructureItem extends Component {
  render () {
    const {name, distance} = this.props;

    return (
      <div className='popup-realty-item'>
        <table>
          <tr>
            <td className='text-align-top'>
              <div className='content'>
                <div className='body'>{name}</div>
                {
                  distance && <div className='footer'>Расстояние: {distance} м.</div>
                }
              </div>
            </td>
          </tr>
        </table>
      </div>
    );
  }
}

export const itemProps = {
  name: PropTypes.string.isRequired,
  distance: PropTypes.number
};

InfrastructureItem.propTypes = itemProps;

InfrastructureItem.defaultProps = {
  distance: 0
};

export default InfrastructureItem;



// WEBPACK FOOTER //
// ./src/ui/Maps/Controls/Popup/InfrastructureItem.jsx